// Import style
import './style.scss';

// Import utilities
import { onReady } from '@automator/utilities';

// Invoke classes when the DOM is ready
onReady( () => {
	new ButtonDropdowns();
} );

export default class ButtonDropdowns {
	constructor() {
		// Create dropdowns
		this.createDropdowns();
	}

	createDropdowns() {
		// Get elements
		[ ...this.$dropdowns ].forEach( ( $dropdown ) => {
			// Create a new dropdown
			new ButtonDropdown( $dropdown );
		} );
	}

	get $dropdowns() {
		return document.querySelectorAll( '.uap-dropdown' );
	}
}

class ButtonDropdown {
	constructor( $dropdown ) {
		this.$dropdown = $dropdown;

		// Listen clicks to toggle open/close
		this.listenClicks();
	}

	get $toggleButton() {
		return this.$dropdown.querySelector( '.uap-dropdown-toggle' );
	}

	getElements( dropdown ) {
		this.$elements = {
			dropdown: dropdown,
			toggleBtn: dropdown.querySelector( '.uap-dropdown-toggle' ),
		};
	}

	listenClicks() {
		// Listen clicks
		this.$toggleButton.addEventListener( 'click', () => {
			// Toggle visibility
			this.toggleMenuVisibility();
		} );
	}

	toggleMenuVisibility() {
		// Check if it's open
		if ( this.isOpen ) {
			// Close it
			this.closeMenu();
		} else {
			// Open it
			this.openMenu();
		}
	}

	openMenu() {
		this.$dropdown.classList.add( 'uap-dropdown--open' );

		// Listen clicks outside
		const listenClicksOutside = ( event ) => {
			// If the click happened outside, close the menu
			if ( ! event.target.closest( '.uap-dropdown' ) ) {
				// Remove event listener
				document.removeEventListener( 'click', listenClicksOutside );

				// Close it
				this.closeMenu();
			}
		};

		// Listen clicks everywhere
		document.addEventListener( 'click', listenClicksOutside, false );
	}

	closeMenu() {
		this.$dropdown.classList.remove( 'uap-dropdown--open' );
	}

	get isOpen() {
		return this.$dropdown.classList.contains( 'uap-dropdown--open' );
	}
}
